import React from "react";

import { Container, Grid, Card, CardContent, Typography } from "@mui/material";

export default function StatsCards({rawData, unit}){

const convertTemp=(c)=>{

if(unit==="F") return c*9/5+32;

if(unit==="K") return c+273.15;

return c;

};

const temperatureData=[...rawData].map(d=>({

temperature:convertTemp(d.temperature)

}));


const avg=(temperatureData.reduce((a,b)=>a+b.temperature,0)/temperatureData.length).toFixed(2);

const min=Math.min(...temperatureData.map(x=>x.temperature)).toFixed(2);

const max=Math.max(...temperatureData.map(x=>x.temperature)).toFixed(2);

if (rawData && rawData.length > 0){
return(

<Container style={{marginTop:10}}>
<Grid container spacing={2}
justifyContent="center" mb={3}>
    <Grid item xs={4}>
        <Card>
            <CardContent>
                Average
                <Typography variant="h5">
                {avg} °{unit}
                </Typography>
            </CardContent>
        </Card>
    </Grid>


    <Grid item xs={4}>
        <Card>
            <CardContent>
                Minimum
                <Typography variant="h5">
                {min} °{unit}
                </Typography>
            </CardContent>
        </Card>
    </Grid>


    <Grid item xs={4}>
        <Card>
            <CardContent>
                Maximum
                <Typography variant="h5">
                {max} °{unit}
                </Typography>
            </CardContent>
        </Card>
    </Grid> 
</Grid>
</Container>

);
}


}
